import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { IdentityService } from '../services/identity.service';
import { RequestHelper } from '../helpers/request.helper';
import { OptionsService } from '../services/options.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
	constructor(
		private readonly os: OptionsService,
		private readonly identityService: IdentityService,
		private readonly injector: Injector
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		/**
		 * process all response errors
		 */
		return next.handle(request).pipe(
			catchError((error: unknown) => {
				/**
				 * if error happened with Identity Service request, or not-authorized request, or it is not an authorization (401) error -
				 * do not change anything and return the error as is
				 */
				if (
					RequestHelper.isIdentityEndpointRequest(request) ||
					!RequestHelper.isAuthorizedRequest(request) ||
					!RequestHelper.isAuthorizationError(error)
				) {
					return throwError(error);
				}

				/**
				 * if options do not allow trying and refresh tokens on error 401 -
				 * process the error and return it
				 */
				if (!this.os.options.refreshTokenOnAuthError) {
					return RequestHelper.onAuthorizationError(error, this.injector);
				}

				/**
				 * if tokens were refreshed - attach the "Authorization" header to the request and call it again;
				 * or process the error if it happens
				 */
				return this.identityService.refreshTokens().pipe(
					switchMap(accessToken =>
						next.handle(RequestHelper.attachAuthorizationHeader(request, accessToken))
					),
					catchError((error: unknown) => RequestHelper.onAuthorizationError(error, this.injector))
				);
			})
		);
	}
}
